module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-cn.02e79cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-cn.png
// module id = 6ykr
// module chunks = 18